// components
import { Tooltip } from '@mui/material';

// styles
import { StyledDataChip } from './DataChip.styles';

const DataChip = ({
  value,
  prefix,
  tooltipValue
}: {
  value: number;
  prefix?: boolean;
  tooltipValue?: string;
}) => {
  const chipColor = value > 0 ? 'success' : value < 0 ? 'error' : 'secondary';

  return (
    <Tooltip title={value < 0 ? tooltipValue : ''} arrow>
      <StyledDataChip
        label={value > 0 && prefix ? `+${value}` : value}
        color={chipColor}
        size="small"
        chipColor={chipColor}
      />
    </Tooltip>
  );
};

export default DataChip;
